import { render, staticRenderFns } from "./AddEvaInfo.vue?vue&type=template&id=05c188b0&scoped=true"
import script from "./AddEvaInfo.vue?vue&type=script&lang=js"
export * from "./AddEvaInfo.vue?vue&type=script&lang=js"
import style0 from "./AddEvaInfo.vue?vue&type=style&index=0&id=05c188b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c188b0",
  null
  
)

export default component.exports